import { Rule, RuleObject } from 'antd/es/form'
import { StoreValue } from 'antd/lib/form/interface'
import { FieldTypeEnum } from 'packages/sdks-next/growp'

import { IFormItemTypeEnum } from './map'

export const rulesMap: { [key: string]: Rule[] } = {
  name: [
    {
      required: true,
      message: '请输入姓名',
    },
  ],
  phone: [
    {
      pattern: /^(?:(?:\+|00)86)?1[3-9]\d{9}$/,
      message: '请输入正确的手机号',
    },
  ],
  email: [
    {
      pattern:
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      message: '请输入正确的邮箱',
    },
  ],
  'guardians.0.phone': [
    {
      pattern: /^(?:(?:\+|00)86)?1[3-9]\d{9}$/,
      message: '请输入正确的手机号',
    },
  ],
  'guardians.1.phone': [
    {
      pattern: /^(?:(?:\+|00)86)?1[3-9]\d{9}$/,
      message: '请输入正确的手机号',
    },
  ],
  url: [
    {
      pattern: new RegExp(
        '^((https|http|ftp|rtsp|mms)?://)' +
          "?(([0-9a-z_!~*'().&=+$%-]+: )?[0-9a-z_!~*'().&=+$%-]+@)?" + //ftp的user@
          '(([0-9]{1,3}.){3}[0-9]{1,3}' + // IP形式的URL- 199.194.52.184
          '|' + // 允许IP和DOMAIN（域名）
          "([0-9a-z_!~*'()-]+.)*" + // 域名- www.
          '([0-9a-z][0-9a-z-]{0,61})?[0-9a-z].' + // 二级域名
          '[a-z]{2,6})' + // first level domain- .com or .museum
          '(:[0-9]{1,4})?' + // 端口- :80
          '((/?)|' + // a slash isn't required if there is no file name
          "(/[0-9a-z_!~*'().;?:@&=+$,%#-]+)+/?)"
      ),
      message: '请输入正确的链接',
    },
  ],
}

export const customizeCountValidator = (
  rule: RuleObject,
  value: StoreValue,
  callback: (error?: string) => void,
  count: {
    max?: number
    min?: number
    type: FieldTypeEnum | IFormItemTypeEnum
  },
  isQuestionnaire?: boolean
) => {
  const { max, min, type } = count
  if (Array.isArray(value) && value.length > 0) {
    const len = value.length
    if (min && len < min) {
      callback(type === 'multi' ? `至少选择${min}项` : `至少上传${min}项`)
    }
    if (max && len > max) {
      callback(type === 'multi' ? `最多选择${max}项` : `最多上传${max}项`)
    }
  }
  callback()
}

export const phoneReg = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/

export const validatePassword = (
  rule: RuleObject,
  value: StoreValue,
  callback: (error?: string) => void
) => {
  const reg =
    /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\W_])^.{8,128}$|(?=.*[a-z])(?=.*[0-9])(?=.*[\W_])^.{8,128}$|(?=.*[A-Z])(?=.*[0-9])(?=.*[\W_])^.{8,128}$|(?=.*[A-Z])(?=.*[a-z])(?=.*[\W_])^.{8,128}$|(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])^.{8,128}$/
  if (!value) {
    callback('请输入密码')
  }
  if (/[\u4e00-\u9fa5]/.test(value)) {
    callback('不能包含中文')
  }
  if (!reg.test(value)) {
    callback(
      '需包含大写字母、小写字母、数字、特色符号四类字符中的三类，要求8-128位'
    )
  }
  callback()
}
